// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-D":"NA1_outdoor-recreation-D__g9HA0"};